// extracted by mini-css-extract-plugin
module.exports = {"icon":"Item_icon__1x9a7"};